import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import installI18nContext from 'modules/i18n/installI18nContext';
import connectToI18n from 'modules/i18n/connectToI18n';
import Paragraph from 'components/Paragraph.jsx';
import Text from 'components/Text.jsx';
import Button from 'components/Button.jsx';
import { getLocaleByCode } from 'modules/utils/locales';
import { acceptDocuments } from 'models/users';
import { PROCESSING, READY } from 'modules/utils/ajaxStatuses';
import Utils from 'modules/utils';

export class DocumentsToSignModal extends React.Component {
    static propTypes = {
        trans: PropTypes.func.isRequired,
        i18n: PropTypes.string.isRequired,
        hasAcceptedSCU: PropTypes.bool,
        hasAcceptedTOS: PropTypes.bool,
        isProfessional: PropTypes.bool,
        userId: PropTypes.number.isRequired,
        closeModal: PropTypes.func.isRequired,
        validateDocumentsOnModel: PropTypes.func.isRequired,
        variant: PropTypes.oneOf(['legacy', 'commissions_be_fr_mc_pf']),
    };

    state = {
        status: READY,
    };

    acceptDocuments = e => {
        this.setState({
            status: PROCESSING,
        });
        acceptDocuments(this.props.userId, this.props.isProfessional).then(() => {
            this.setState({
                status: READY,
            });
            this.props.validateDocumentsOnModel();
            this.props.closeModal(e);
        });
    };

    renderLegacyContainerContent = () => {
        const { trans, i18n, hasAcceptedSCU, hasAcceptedTOS, isProfessional } = this.props;
        const localeConfig = getLocaleByCode(i18n);

        return (
            <Fragment>
                <Paragraph
                    size="large"
                    dangerouslySetInnerHTML={{
                        __html: trans('documents.to.sign.new.documents.intro'),
                    }}
                />
                <ul className="u-mb-2">
                    {!hasAcceptedSCU && isProfessional && (
                        <li>
                            <Text
                                size="large"
                                dangerouslySetInnerHTML={{
                                    __html: trans('documents.to.sign.SCU'),
                                }}
                            />
                        </li>
                    )}
                    {!hasAcceptedTOS && (
                        <Fragment>
                            <li>
                                <Text
                                    size="large"
                                    dangerouslySetInnerHTML={{
                                        __html: trans('documents.to.sign.TOS'),
                                    }}
                                />
                            </li>
                            <li>
                                <Text size="large">{trans('documents.to.sign.privacy')}</Text>
                            </li>
                        </Fragment>
                    )}
                </ul>
                <Text
                    className="u-mb-2"
                    size="large"
                    dangerouslySetInnerHTML={{
                        __html: trans('documents.to.sign.new.documents.page', {
                            '%url%': localeConfig.cguPage,
                        }),
                    }}
                />
                <Paragraph
                    className="u-mb-2"
                    size="large"
                    dangerouslySetInnerHTML={{
                        __html: trans('documents.to.sign.new.documents.paragraph1'),
                    }}
                />
                <Paragraph className="u-mb-2" size="large">
                    {trans('documents.to.sign.new.documents.paragraph2')}
                </Paragraph>
                <Paragraph className="u-mb-2" size="large">
                    {trans('documents.to.sign.new.documents.paragraph3')}
                </Paragraph>
                <ul className="u-mb-4">
                    <li>
                        <Text
                            size="large"
                            dangerouslySetInnerHTML={{
                                __html: trans('documents.to.sign.new.documents.contact.privacy', {
                                    '%mail%': localeConfig.privacyEmail,
                                }),
                            }}
                        />
                    </li>
                    <li>
                        <Text
                            size="large"
                            dangerouslySetInnerHTML={{
                                __html: trans('documents.to.sign.new.documents.contact.support', {
                                    '%mail%': localeConfig.supportEmail,
                                }),
                            }}
                        />
                    </li>
                </ul>
            </Fragment>
        );
    };

    renderCommissionsBEFRMCPFContainerContent = () => {
        const { i18n, isProfessional, trans } = this.props;
        const { supportEmail } = getLocaleByCode(i18n);

        if (!isProfessional) {
            return (
                <Paragraph
                    className="u-mb-4"
                    size="large"
                    dangerouslySetInnerHTML={{
                        __html: trans('documents.to.sign.commissions.members.paragraph'),
                    }}
                />
            );
        }

        return (
            <Fragment>
                <Paragraph
                    size="large"
                    dangerouslySetInnerHTML={{
                        __html: trans('documents.to.sign.commissions.professionals.intro'),
                    }}
                />
                <ul className="fa-text--large u-mb-4">
                    <li
                        dangerouslySetInnerHTML={{
                            __html: trans('documents.to.sign.commissions.professionals.cpu'),
                        }}
                    />
                    <li
                        dangerouslySetInnerHTML={{
                            __html: trans('documents.to.sign.commissions.professionals.charter'),
                        }}
                    />
                </ul>
                <Paragraph size="large">
                    {trans('documents.to.sign.commissions.professionals.updates')}
                </Paragraph>
                <ul className="fa-text--large u-mb-4">
                    <li
                        dangerouslySetInnerHTML={{
                            __html: trans('documents.to.sign.commissions.professionals.cpu21'),
                        }}
                    />
                    <li
                        dangerouslySetInnerHTML={{
                            __html: trans('documents.to.sign.commissions.professionals.cpu22'),
                        }}
                    />
                    <li
                        dangerouslySetInnerHTML={{
                            __html: trans('documents.to.sign.commissions.professionals.charter7'),
                        }}
                    />
                </ul>
                <Paragraph
                    className="u-mb-4"
                    size="large"
                    dangerouslySetInnerHTML={{
                        __html: trans('documents.to.sign.commissions.professionals.paragraph', {
                            '%mail%': supportEmail,
                        }),
                    }}
                />
            </Fragment>
        );
    };

    render() {
        const { isProfessional, trans, variant, i18n } = this.props;

        return (
            <Fragment>
                <div className="documentsToSignModal-container">
                    {variant === 'commissions_be_fr_mc_pf'
                        ? this.renderCommissionsBEFRMCPFContainerContent()
                        : this.renderLegacyContainerContent()}
                </div>
                <Button
                    loading={this.state.status === PROCESSING}
                    variant="success"
                    onClick={this.acceptDocuments}
                >
                    {trans('documents.to.sign.accept')}
                </Button>
                {variant === 'commissions_be_fr_mc_pf' && !isProfessional && (
                    <Fragment>
                        <div className="u-mb-6" />
                        <Paragraph
                            size="small"
                            dangerouslySetInnerHTML={{
                                __html: trans('documents.to.sign.commissions.members.account', {
                                    '%url%': Utils.linkTo(
                                        `/${i18n}/configuration/account/identity`
                                    ),
                                }),
                            }}
                        />
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

export default installI18nContext(connectToI18n(DocumentsToSignModal));
